export default function AboutUs() {
  return (
  <div id="page">
        <div className="page-inner">
          <div id="main">
            <div className="about">
				<h1 style={{marginTop: "0"}}>About Us</h1>
				<p>The World Factbook of Food was originally developed by the Food Protection and Defense Institute (FPDI) through funding from the Department of Homeland Security Science and Technology Directorate. Today, iDecisionSciences (IDS) manages and continues to develop the World Factbook of Food. The site is designed to serve as a central reference repository of data related to food. Data has been collected from multiple sources on a variety of topics including production, trade, common food and non-food uses, seasonality, processing steps and supply chain structure, food safety concerns, and past intentional adulteration events.</p>
				<h1>iDecisionSciences</h1>
				<p>Established in 2009, the company has managed confidential supply chain data and provided software and professional services on behalf of the food industry.  Led by an experienced team of professionals with more than sixty combined years in the food industry, the team works to identify and understand client vulnerabilities and develop actionable plans. IDS strives to enable clients to have a better understanding of their vulnerabilities and provide them with the information and tools they need for clear direction and effective solutions.</p>
				<h3 style={{marginTop:"-20px"}}>
					Visit IDS:
					<a href="https://www.idecisionsciences.com/" target="_blank" rel="noreferrer">www.idecisionsciences.com</a>
				</h3>
				<h1 style={{marginTop: "40px"}}>Connect with IDS</h1>
				<ul className="connect-social clearfix">
					<li>
						<a href="https://twitter.com/iDecisionSci" target="_blank" rel="noreferrer" >
						<span className="fa fa-x-twitter"></span>
						</a>
					</li>
					<li>
						<a href="mailto:info@idecisionsciences.com" target="_blank" rel="noreferrer" >
						<span className="fa fa-envelope"></span>
						</a>
					</li>
				</ul>
			</div>
          </div>
        </div>
      </div>
  );
}
